import { Formik } from 'formik';
import _ from 'lodash';
import React from 'react';
import { MdAdd, MdCheck, MdKeyboardBackspace } from 'react-icons/md';
import { IconButton } from '~/components/crud/styles';
import FloatingButton from '~/components/floatbutton';
import Kanban from '~/components/kanban';
import Spinner from '~/components/spinner';
import useAuth from '~/view-data/use-auth';
import useEvents from '~/view-data/use-events';
import useHeader from '~/view-data/use-header';
import FormFilter from '~/views/events/filter';
import { Container, FormToolbar } from '~/views/events/styles';

function Events({ acls }) {
  const canWrite = acls.includes('W'),
    canAccredit= acls.includes('C'),
    { state, actions } = useEvents(),
    { state: authState } = useAuth(),
    { state: headerState, actions: headerActions } = useHeader(),
    user = _.get(authState, 'user') || {};

  function Filter() {
    return (
      <div className='right'>
        <Formik
          onSubmit={actions.list}
          initialValues={_.get(headerState, 'filter.data') || {}}
          enableReinitialize={true}
          validateOnMount={true}
          >
          {(args) => {
            return (
              <>
                <FormFilter {...args} />
                <FormToolbar>
                  <Spinner visible={state.loading} />
                  <div className='buttons'>
                    <IconButton
                      title='Cancelar'
                      disabled={state.loading}
                      onClick={headerActions.hideFilter}
                      >
                      <MdKeyboardBackspace />
                    </IconButton>
                    <IconButton
                      title='Aplicar Filtro'
                      disabled={state.loading}
                      onClick={args.handleSubmit}
                      >
                      <MdCheck />
                    </IconButton>
                  </div>
                </FormToolbar>
              </>
            );
          }}
        </Formik>
      </div>
    );
  };

  const showFilter = _.get(headerState, 'filter.visible');

  return (
    <Container showForm={showFilter}>
      <div className='left'>
        <Kanban
          boardField="status"
          loading={state.loading}
          boards={state.data.boards}
          cardOptions={state.cardOptions}
          cards={state.data.cards}
          onCardClick={actions.load(canWrite, canAccredit, user)}
          />
        { (canWrite && !showFilter) &&
          <FloatingButton
            icon={MdAdd}
            onClick={actions.load(canWrite, canAccredit, user)}
          />
        }
      </div>
      <Filter />
    </Container>
  )

}

export default Events;